import { render, staticRenderFns } from "./vis-form-input.vue?vue&type=template&id=462d6539"
import script from "./vis-form-input.vue?vue&type=script&lang=js"
export * from "./vis-form-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports